import {
  setupGlobalEnv
} from "./chunk-TNCD3Q47.js";

// src/vite.ts
var setupViteEnv = (envVars, appName) => {
  const logPrefix = appName ? `[${appName}/env]` : "[vite/env]";
  console.info(`${logPrefix} Initializing global environment...`);
  const finalEnvVars = {
    NEXT_PUBLIC_ENV: "LOCAL",
    NEXT_PUBLIC_ENV_FRONTEND_ORIGIN: "http://localhost:5173",
    NEXT_PUBLIC_ENV_CLOUDFLARE_IMAGE_ORIGIN: "https://dev.skin-seoul.com",
    NEXT_PUBLIC_ENV_SERVER_ORIGIN: "https://dev.skin-seoul.com/api",
    ...envVars
  };
  console.info(`${logPrefix} Final environment variables:`, finalEnvVars);
  setupGlobalEnv(finalEnvVars);
  console.info(`${logPrefix} Global environment initialized successfully`);
};
export {
  setupViteEnv
};
